<form (submit)="doLogin($event)" [formGroup]="loginForm">
  <div class="modal-title-container">
    <h1 translate class="text-center mb-40 text-xl3">LOGIN.CONTAINERS.LOGIN.TITLE</h1>
  </div>
  <div class="modal-content-container">
    <p class="text-gold error-message text-center mb-20 ml-auto mr-auto" *ngIf="errorMessage">
      <svg-icon src="/assets/images/svg/rebrand/warning-triangle.svg"></svg-icon>
      {{ errorMessage | titlecase }}
    </p>
    <div class="inputs">
      <div
        class="input input-text input-lg mb-20"
        [class.input-error]="formHelperService.isInputInvalid(loginForm, 'email')"
      >
        <input type="email" name="email" placeholder="Email" formControlName="email" autocomplete="username" />
      </div>
      <div
        class="input input-text relative input-lg mb-20"
        [class.input-error]="formHelperService.isInputInvalid(loginForm, 'password')"
      >
        <input
          [type]="showPassword ? 'text' : 'password'"
          name="password"
          placeholder="Password"
          formControlName="password"
          autocomplete="current-password"
        />
        <div>
          <svg-icon
            src="assets/images/svg/rebrand/view.svg"
            (mousedown)="toggleShowPassword()"
            (mouseup)="toggleHidePassword()"
            (touchstart)="toggleShowPassword()"
            (touchend)="toggleHidePassword()"
          >
          </svg-icon>
        </div>
      </div>
    </div>
    <div class="flex justify-between items-baseline">
      <div class="input input-checkbox input-transparent">
        <label>
          <input id="" name="" type="checkbox" formControlName="rememberMe" />
          <span class="selector"></span>
          Remember me
        </label>
      </div>

      <a class="text-blue" [routerLink]="['/login/password-recover']">Forgot password?</a>
    </div>
  </div>
  <div class="modal-actions-container">
    <button
      class="btn btn-yellow btn-xl mt-35 w-full justify-center"
      #submitBtn
      [class.btn-disabled]="isLoggingIn || loginForm.invalid"
      (click)="doLogin($event)"
    >
      Sign in
    </button>
  </div>
</form>
